import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';

// Components.
import JetpackForm from '../jetpack-form';
import Modal from '../modal';

// Styles.
import './soft-gate.scss';

// Set the namespaced API root.
const apiRoot = `${window.wpApiSettings.root}kauffman/v1`;

const SoftGateForm = ({
  formId,
  mediaUrl,
  unmount,
}) => (
  <Modal dismiss={unmount}>
    <JetpackForm
      configUrl={`${apiRoot}/soft-gate-form-config?form_id=${formId}`}
      formId={formId}
      mediaUrl={mediaUrl}
      nonce={window.wpApiSettings.nonce}
      postSubmit={() => setTimeout(
        () => {
          window.location.href = mediaUrl;
        },
        2500
      )}
      submitUrl={`${apiRoot}/soft-gate-form-submit`}
    />
  </Modal>
);

SoftGateForm.propTypes = {
  formId: PropTypes.number.isRequired,
  mediaUrl: PropTypes.string.isRequired,
  unmount: PropTypes.func.isRequired,
};

/**
 * An event handler for clicks on links to soft-gated resources.
 * @param {Event} event - The click event.
 */
const handleClick = (event) => {
  event.preventDefault();
  event.stopPropagation();
  const element = document.createElement('div');
  document.body.appendChild(element);
  ReactDOM.render(
    <SoftGateForm
      formId={parseInt(event.currentTarget.dataset.formId, 10)}
      mediaUrl={event.currentTarget.href}
      unmount={() => ReactDOM.unmountComponentAtNode(element)}
    />,
    element
  );
};

// Look for soft-gated PDF links and bind a listener to each.
Array.from(document.querySelectorAll('.download-soft-gated'))
  .forEach((element) => element.addEventListener('click', handleClick));
